module.exports = "<p>\n  edge works!\n</p>\n"